import { render } from "./d-loby.vue?vue&type=template&id=0f32de02&scoped=true&ts=true"
import script from "./d-loby.vue?vue&type=script&lang=ts"
export * from "./d-loby.vue?vue&type=script&lang=ts"

import "./d-loby.vue?vue&type=style&index=0&id=0f32de02&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f32de02"]])

export default __exports__